import { CopyRow } from "@/components/agent/ui";
import { applyUrl, criteriaUrl } from "@/lib/format";

export const PropertyKeys = ({ linkToken }) => (
  <div className="flex flex-col gap-3" data-testid="property-keys">
    <CopyRow label="Apply link" value={applyUrl(linkToken)} testid="apply-url" />
    <CopyRow label="Criteria page" value={criteriaUrl(linkToken)} testid="criteria-url" />
    <CopyRow label="Property key" value={linkToken} testid="property-key" />
  </div>
);
